import React from "react";
import "./Terms_Conditions.css";
import Decline_Btn from "../common_components/common_btn/decline_btn/Decline_Btn";
import Accept_Btn from "../common_components/common_btn/accept_btn/Accept_Btn";
import Common_Banner from "../common_components/common_banner/Common_Banner";
import Book_Vehicle from "../common_components/book_vehicle/Book_Vehicle";

const Terms_Conditions = () => {
  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: "Terms & Conditions", link: "", isActive: true },
  ];

  return (
    <>
      <section className="Terms_Conditions Privacy_Policy">
        <Common_Banner
          imgSrc={"/assets/images/common_banners/terms_conditions.png"}
          title_text="Terms & Conditions"
          breadcrumbs={breadcrumbs}
        />

        <div className="container">
          <div className="card card_div">
            {/* <p className="intro">
              These Terms & Conditions (“Terms”) govern your use of our website,
              mobile application, and services. By accessing or using our
              platform, you agree to be bound by these Terms. Please read them
              carefully before using our services.
            </p> */}

            <h2 className="head_div">1. Introduction</h2>
            <div className="description_div">
              <p className="grey_class">
                Welcome to Gravity Drive ("the App"), a ride-hailing platform
                operated by Gravity Drive Smartech Pvt. Ltd. ("we", "us", or
                "our"). These Terms and Conditions ("Terms") govern your use of
                the Gravity Drive App and its services. By downloading,
                installing, or using the App, you agree to comply with these
                Terms. Our Website :- gravitydrive.in
              </p>
              <p className="grey_class">
                If you do not agree to these Terms, you must refrain from using
                the App.
              </p>
            </div>

            <h2 className="head_div">2. Eligibility</h2>
            <div className="description_div">
              <p className="grey_class">
                <ul>
                  <li>You must be at least 18 years old to use the App.</li>
                  <li>
                    You must have a valid mobile device, internet connection,
                    and access to authorized platforms (e.g., Google Play Store)
                    to download the App.
                  </li>
                  <li>
                    Drivers must possess:
                    <ul>
                      <li>A valid driving license;</li>
                      <li>Vehicle registration documents;</li>
                      <li>
                        Comprehensive insurance coverage as per applicable local
                        laws.
                      </li>
                    </ul>
                  </li>
                </ul>
              </p>
            </div>

            <h2 className="head_div">3. User Accounts</h2>
            <div className="description_div">
              <p className="grey_class">
                <ul>
                  <li>
                    To use the App, you must create an account by providing
                    accurate information, including your name, phone number,
                    email address, and payment details.
                  </li>
                  <li>
                    You are solely responsible for maintaining the
                    confidentiality of your account credentials.
                  </li>
                  <li>
                    We reserve the right to suspend or terminate accounts that
                    violate these Terms or engage in fraudulent activities,
                    without prior notice.
                  </li>
                </ul>
              </p>
            </div>

            <h2 className="head_div">4. Services</h2>
            <div className="description_div">
              <p className="grey_class">
                <ul>
                  <li>
                    The App connects riders ("Users") with drivers ("Gravity
                    DriverS") for transportation services.
                  </li>
                  <li>
                    We act as an intermediary and do not own, operate, or
                    maintain vehicles used for rides.
                  </li>
                  <li>
                    Users can book rides, track trips in real-time, and make
                    payments through the App.
                  </li>
                </ul>
              </p>
            </div>

            <h2 className="head_div">5. Payment Terms</h2>
            <div className="description_div">
              <p className="grey_class">
                <ul>
                  <li>
                    Payments for rides are processed through secure payment
                    gateways integrated into the App.
                  </li>
                  <li>
                    Fares are calculated based on:
                    <ul>
                      <li>Distance traveled;</li>
                      <li>Time taken;</li>
                      <li>Applicable taxes;</li>
                      <li>Dynamic pricing during peak hours.</li>
                    </ul>
                  </li>
                  <li>
                    Payment methods include cash, credit/debit cards, and
                    digital wallets.
                  </li>
                  <li>
                    Any disputes regarding fares must be reported within 7 days
                    of the ride. Failure to report within this timeframe may
                    result in forfeiture of the claim.
                  </li>
                </ul>
              </p>
            </div>

            <h2 className="head_div">6. Cancellation Policy</h2>
            <div className="description_div">
              <p className="grey_class">
                <ul>
                  <li>
                    Users:
                    <ul>
                      <li>
                        You may cancel rides before the driver starts the trip.
                        A cancellation fee may apply if the cancellation occurs
                        after the driver has been assigned.
                      </li>
                    </ul>
                  </li>
                  <li>
                    Drivers:
                    <ul>
                      <li>
                        Drivers may cancel rides only under exceptional
                        circumstances (e.g., safety concerns). Frequent
                        cancellations by drivers may result in penalties,
                        including suspension or termination of their accounts.
                      </li>
                    </ul>
                  </li>
                </ul>
              </p>
            </div>

            <h2 className="head_div">7. Liability Disclaimer</h2>
            <div className="description_div">
              <p className="grey_class">
                <ul>
                  <li>
                    We are not liable for any damages, injuries, or losses
                    incurred during rides unless caused by our gross negligence
                    or willful misconduct.
                  </li>
                  <li>
                    Drivers are independent contractors and are solely
                    responsible for their actions, including compliance with
                    traffic laws and safety standards.
                  </li>
                  <li>
                    Users assume full responsibility for ensuring their safety
                    during rides and agree to hold us harmless from any claims
                    arising out of their use of the App.
                  </li>
                </ul>
              </p>
            </div>

            <h2 className="head_div">8. Prohibited Activities</h2>
            <div className="description_div">
              <p className="grey_class">
                Misuse of the App, including harassment, fraud, or illegal
                activities, is strictly prohibited.
              </p>
              <p className="grey_class">Users must not:</p>
              <p className="grey_class">
                <ul>
                  <li>
                    Share their account credentials or allow unauthorized access
                    to their accounts;
                  </li>
                  <li>
                    Use the App for any purpose other than its intended
                    functionality;
                  </li>
                  <li>
                    Engage in activities that violate applicable laws or harm
                    the App’s integrity.
                  </li>
                </ul>
              </p>
            </div>

            <h2 className="head_div">9. Intellectual Property</h2>
            <div className="description_div">
              <p className="grey_class">
                <ul>
                  <li>
                    All content, logos, trademarks, and software associated with
                    the App are the property of Gravity Drive Smartech Pvt. Ltd.
                    and are protected by intellectual property laws.
                  </li>
                  <li>
                    Unauthorized use, reproduction, or distribution of any
                    materials is strictly prohibited.
                  </li>
                </ul>
              </p>
            </div>

            <h2 className="head_div">10. Modifications to Terms</h2>
            <div className="description_div">
              <p className="grey_class">
                <ul>
                  <li>
                    We reserve the right to update these Terms at any time.
                    Changes will be effective upon posting on the App or
                    website.
                  </li>
                  <li>
                    Continued use of the App after changes constitutes
                    acceptance of the updated Terms.
                  </li>
                </ul>
              </p>
            </div>

            {/* <h2 className="head_div">11. Modification of Term</h2>
            <div className="description_div">
              <p className="grey_class">
                Our website/app may contain links to third-party websites. We
                may update or modify these Terms at any time without prior
                notice. The updated Terms will be posted on this page with the
                “Last Updated” date.
              </p>
            </div>

            <h2 className="head_div">12. Contact Us</h2>
            <div className="description_div">
              <p className="grey_class">
                If you have any questions about this Privacy Policy, please
                contact us:
              </p>
              <p className="grey_class">📧 Email: support@autocarepro.com</p>
              <p className="grey_class">📞 Phone: +91 98765 43210</p>
              <p className="grey_class">
                🏢 Address: Gravitydrive Pro Pvt. Ltd., Sector 18, Pune –
                110089, India
              </p>
            </div> */}
            {/* Buttons container */}
            {/* <div className="btn_class d-flex justify-content-center gap-2 ">
              <Decline_Btn />
              <Accept_Btn />
            </div> */}
          </div>
        </div>
      </section>
      <Book_Vehicle />
    </>
  );
};

export default Terms_Conditions;
